import React from "react";
import { ListItem, ListItemButton, ListItemIcon, ListItemText, Tooltip, Typography } from "@mui/material";
import { Submenu } from "../../typings/Submenu";
import { useUIMode } from "../../wms/src/context/UIContext";


interface SingleLevelProps {
  item: Submenu;
  handleSubitemClick: (item: Submenu) => void;
  selectedItem?: string | null;
  onSelectItem?: (id: string) => void;
  forceExpanded?: boolean;
}

export const SingleLevel: React.FC<SingleLevelProps> = ({
  item,
  handleSubitemClick,
  selectedItem,
  onSelectItem,
  forceExpanded
}) => {
  const handleSubitemClickHandler = (item: Submenu) => () => {
    handleSubitemClick(item);
    if (onSelectItem) {
      onSelectItem(item.url);
    }
  }
  
  const IconComponent = item.icon;

  const { isShortMode, isCollapsed: collapsedMode } = useUIMode();
  const isCollapsed = collapsedMode && !forceExpanded;

  return (
    <ListItem disablePadding>
      <Tooltip title={isCollapsed ? item.name : ""} placement="right">
        <ListItemButton
          onClick={handleSubitemClickHandler(item)}
          sx={{
            ...(isCollapsed ? { px: 0 } : { pl: item.identation || 2 }),
            justifyContent: isCollapsed ? 'center' : 'flex-start',
            '&.Mui-selected': (theme) => ({
              backgroundColor: `${theme.palette.primary.main} !important`,
              color: 'white'
            })
          }}
          selected={selectedItem === item.url}
        >
          <ListItemIcon sx={{ minWidth: isCollapsed ? 0 : 36, justifyContent: isCollapsed ? 'center' : 'flex-start' }}>
            {IconComponent && React.createElement(IconComponent as any, { sx: { fontSize: '20px' } })}
          </ListItemIcon>
          {!isCollapsed && (
            <ListItemText
              primary={
                <Typography style={{ fontSize: isShortMode ? '19px' : '16px' }}>
                  {item.name}
                </Typography>
              }
            />
          )}
        </ListItemButton>
      </Tooltip>
    </ListItem>
  );
};